import apiCall from './api';
import api, { setAuth0Methods } from './axios';

// Export axios instance as default
export default api;

// Export auth methods
export { setAuth0Methods };

// Configs - Updated to match original endpoints
export const getConfigs = () => apiCall('/admin/configurations/');
export const getConfig = (id) => apiCall(`/admin/configurations/${id}`);
export const createConfig = (data) => apiCall('/admin/configurations/', 'POST', data);
export const updateConfig = (id, data) => apiCall(`/admin/configurations/${id}`, 'PUT', data);
export const deleteConfig = (id) => apiCall(`/admin/configurations/${id}`, 'DELETE');

// Enums
export const getEnum = (enumType) => apiCall(`/enum/${enumType}/`);
export const createEnum = (enumType, data) => apiCall(`/enum/${enumType}/`, 'POST', data);
export const deleteEnum = (enumType, id) => apiCall(`/enum/${enumType}/${id}`, 'DELETE');

// Interaction Categories - Updated to match backend endpoints
export const getInteractionCategories = (configId) => apiCall(`/admin/interaction_categories/${configId}`);
export const createInteractionCategory = (configId, data) => apiCall(`/admin/interaction_categories/`, 'POST', data);
export const deleteInteractionCategory = (id) => apiCall(`/admin/interaction_categories/${id}`, 'DELETE'); 